import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { DecisionMaker } from './components/DecisionMaker';
import { Description } from './components/Description';
import { Media } from './components/Media';
import { Title } from './components/Title';

export const PetitionContent: React.FC = () => {
	return (
		<>
			<Text variant="heading" size="x-small" as="p">
				<Translate value="corgi.petition.edit.petition_content.heading" />
			</Text>
			<div className="flex flex-col gap-6">
				<Title />
				<Description />
				<Media />
			</div>
			<div className="mt-14">
				<DecisionMaker />
			</div>
		</>
	);
};
